import React from 'react';
import ProgramManager from '../ProgramManager';

export default function SalesSOSearch() {
  // Use ProgramManager in read-only mode for sales dashboard
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold">SO Search & View</h2>
        <p className="text-gray-600 mt-1">Search for existing Scheduled Offerings and view their details</p>
      </div>
      <ProgramManager 
        readOnly={true} 
        hideNavButtons={true} 
        salesMode={true}
      />
    </div>
  );
}